import { Events } from 'global/constants';

const { events } = window.od;

// eslint-disable-next-line import/prefer-default-export
export const addErrorEventListener = () => {
	window.addEventListener(
		'error',
		e => publishEvent(Events.GLOBAL_JS_ERROR_REPORTED, e),
		false,
	);
};

const publishEvent = (eventName, eventData) =>
	events.publish(eventName, eventData);
